<template>
  <div class="popup-controller">

    <!-- @todo popup Hulptool -->
    <popup
        @close="$emit('close')"
        v-if="popup === 'DecisionAid'"
        :max-width="700"
    >
      <decision-aid @close="$emit('close')" @clickedHoseRow="setHoseLpm"></decision-aid>
    </popup>


    <!-- @todo popup koppelingen -->
    <popup
        @close="$emit('close')"
        v-if="popup === 'couplingA' || popup === 'couplingB'"
        :max-width="1160"
    >
      <popup-couplings
          :popup="popup"
          @close="$emit('close')"
      ></popup-couplings>
    </popup>

    <!-- @todo popup Verdraaiing -->
    <popup
        @close="$emit('close')"
        v-if="popup === 'rotation'"
        :max-width="700"
    >
      <rotation-popup @close="$emit('close')"></rotation-popup>
    </popup>
  </div>
</template>

<script>

import Popup from "@/components/hose/components/Popup";
import Tabs from "@/components/hose/components/Tabs";
import {mapGetters} from "vuex";
import CategoryCard from "@/components/hose/components/CategoryCard";
import DecisionAid from "@/components/hose/components/DecisionAid";
import RotationCard from "@/components/hose/components/RotationCard";
import GridTable from "@/components/hose/components/GridTableHoses";
import GridRow from "@/components/hose/components/GridRowHoses";
import GridRowCouplings from "@/components/hose/components/GridRowCouplings";
import PopupCouplings from "@/components/hose/components/PopupCouplings";
import RotationPopup from "@/components/hose/components/RotationPopup";

export default {
  name: "PopupController",

  components: {
    RotationPopup,
    PopupCouplings, GridRowCouplings, GridTable, RotationCard, DecisionAid, CategoryCard, Tabs, Popup
  },

  props: {
    popup: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapGetters({
      preferences: 'build/hoses/getHosePreferences',
      build: "build/hoses/getHoseBuild",
      allHoses: "build/hoses/hoses/getAll",
      allCouplings: 'build/hoses/couplings/getAllCouplings'
    }),
  },

  methods: {
    setHoseLpm(val) {
      this.$store.commit('build/hoses/setLpm', +val);
    },
  }
}
</script>

<style scoped lang="scss">
.coupling-info-popup {
  display: flex;
  height: 100%;
  max-height: 150px;

  .left {
    display: flex;
    background-color: #EBEBEB;
    padding: 8px;
    max-width: 78px;
    flex-direction: column;

    .icon {
      margin-top: 22px;
      position: relative;
      left: -8px;
      max-width: 60px;
      max-height: 60px;
    }

    .measurement {
      margin-top: 4px;
      margin-bottom: 25px;
      font-size: 12px;
    }
  }

  .title {
    width: 100%;
    font-size: 12px;
    font-family: neue-haas-grotesk-display, sans-serif;
  }

  .right {
    display: flex;
    padding: 8px;
    padding-left: 10px;
    flex-wrap: wrap;

    .title {
      margin-left: 12px;
    }

    .icon {
      margin-bottom: 30px;
      margin-left: 21px;
      max-width: 100%;
      height: auto;
    }

    .measurement {
      margin-top: 4px;
      margin-bottom: 25px;
      font-size: 12px;
      position: absolute;

      &.middle {
        left: 150px;
        top: 110px;
      }
      &.right {
        left: 188px;
        top: 74px;
      }
    }
  }
  .close-btn {
    color: #A4AFB7;
    font-size: 40px;
    cursor: pointer;
    transition: all ease 0.3s;
    position: relative;
    top: -12px;
    right: 12px;


    &:hover {
      color: darken(#A4AFB7, 40%);
    }
  }
}
</style>